// @ts-strict-ignore
import { emersonRoutes } from "@emerson/data/emersonRoutes";
import { getParamsString } from "@shared/hooks/useUrlParams/useUrlParams";
import type { ProductTaxonomy } from "@shared/types/graphqlGenerated";

type ProductTaxonomyType = Pick<ProductTaxonomy, "id" | "name" | "parent">;

const getBreadcrumbLinkItems = (taxonomy: ProductTaxonomyType): any[] => {
  if (!taxonomy) return [];

  const { parent } = taxonomy;

  return [getTaxonomy(taxonomy), getTaxonomy(parent), getTaxonomy(parent?.parent)]
    .filter(taxon => taxon !== null)
    .reverse();
};

const getTaxonomy = (taxonomy: ProductTaxonomyType) => {
  if (!taxonomy) return null;

  const { id, name } = taxonomy;

  const categoryParams = getParamsString({
    taxonomies: [{ id, name }],
  });

  return {
    title: taxonomy.name,
    href: `${emersonRoutes.shop.catalog}?${categoryParams}`,
  };
};
export { getBreadcrumbLinkItems };
